<template>
	<a-card>
		<a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
			<a-form-item label="需求名称" name="name">
				<a-input v-model:value="searchForm.name" placeholder="请输入需求名称" />
			</a-form-item>
			<a-form-item>
				<a-button type="primary" @click="onSearch">查询</a-button>
				<a-button @click="onReset">重置</a-button>
			</a-form-item>
		</a-form>
		<div class="table-toolbar">
			<a-button type="primary" @click="onAdd">
				<template #icon>
					<plus-outlined />
				</template>
				新增
			</a-button>
			<a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)">
				<a-button danger>批量删除</a-button>
			</a-popconfirm>
		</div>
		<a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
			<template #message>
				已选择 {{ selectedRowKeys.length }} 项
				<a @click="onClearSelected" class="ml-20 float-right">清空</a>
			</template>
		</a-alert>
		<a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
			:pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
			<!-- <template #index="{index}">{{ index + 1 }}</template> -->
			<template #name="{ record }">
				<a @click="onDetail(record)">{{ record.name }}</a>
			</template>
			<template #trType="{ text }">
				<dict-render :dict-obj="dictObjs['demand_type']" :text="text"></dict-render>
			</template>
			<template #highTechField="{ text }">
				<dict-render :dict-obj="dictObjs['belong_techField']" :text="text"></dict-render>
			</template>
			<template #priority="{ text }">
				<dict-render :dict-obj="dictObjs['demand_priority']" :text="text"></dict-render>
			</template>
			<template #isShow="{ record }">
				<switch-btn :value="record.isShow" key-field="isShow" :switch-url="editUrl" :checkedValue="'0'"
					:uncheckedValue="'1'" :params="{ id: record.key }" @ok="loadData" />
			</template>
			<template #action="{ record }">
				<div class="table-row-operations">
					<a @click="onEdit(record)">编辑</a>
					<a @click="onDocking(record)">对接列表</a>
				</div>
			</template>
		</a-table>
	</a-card>
	<UserModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
	<DetailModal ref="detailModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
	<DockingModal ref="dockingModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
</template>

<script>
import { dictMixin, tableListMixin } from "@/mixins";
import { technicalRequirementsInfo } from "@/api/achievementsService";
import DictRender from "@/components/other/DictRender";
import { defaultDateCustomRender } from '@/utils/customRender';
import UserModal from "./components/UserModal";
import DetailModal from "./components/DetailModal";
import DockingModal from "./components/DockingModal";

const columns = [
	// {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
	// { title: "企业名称", dataIndex: "companyName", key: "companyName" },
	{ title: "需求名称", dataIndex: "name", key: "name", slots: { customRender: "name" } },
	{ title: "需求类型", dataIndex: "trType", key: "trType", slots: { customRender: "trType" } },
	{ title: "所属高新技术领域", dataIndex: "highTechField", key: "highTechField", slots: { customRender: "highTechField" } },
	{ title: "截止日期", dataIndex: "deadline", key: "deadline", customRender: defaultDateCustomRender },
	// { title: "需求优先级", dataIndex: "priority", key: "priority", slots: { customRender: "priority" } },
	// { title: "是否公开", dataIndex: "isShow", key: "isShow", slots: { customRender: "isShow" } },
	{ title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
	name: "index",
	mixins: [tableListMixin, dictMixin],
	components: {
		DictRender, UserModal, DetailModal, DockingModal
	},
	data() {
		return {
			dictNames: 'isPublic,demand_priority,demand_type,belong_techField',
			columns,
			queryParamFixed: {},
			listUrl: technicalRequirementsInfo.pageList,
			listKeyField: "id",
			deleteUrl: technicalRequirementsInfo.remove,
			editUrl: technicalRequirementsInfo.saveOrUpdate,
			jointId: '',
			abutmentId: ''
		}
	},
	methods: {
		onAdd() {
			this.onShowModal('modal');
		},
		onEdit(record) {
			this.getAction({
				url: technicalRequirementsInfo.detail,
				params: { id: record.id }
			}).then(res => {
				this.onShowModal('modal', res);
			})
		},
		onDetail(record) {
			this.getAction({
				url: technicalRequirementsInfo.detail,
				params: { id: record.id }
			}).then(res => {
				this.onShowModal('detailModal', res)
			})
		},
		onDocking(record) {
			this.getAction({
				url: technicalRequirementsInfo.detail,
				params: { id: record.id }
			}).then(res => {
				this.onShowModal('dockingModal', res)
			})
		},
		onCloseModel() {
			this.loadData(1)
		},
	}
}
</script>

<style scoped></style>
